_createCheckoutOrder